(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ad-slideshow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var slides = document.querySelectorAll('.slideshow-slide');
  var carousel = document.querySelector('.slideshow-carousel');
  var paginationContainer = document.querySelector('.slideshow-pagination');

  var totalSlides = slides.length;
  var currentIndex = 0;
  var autoSlide;

  var speed = parseInt(carousel.dataset.speed) || 5000;
  var effect = carousel.dataset.effect;

  slides.forEach(function (_, index) {
    var dot = document.createElement('div');
    dot.classList.add('slideshow-dot');
    if (index === 0) dot.classList.add('active');

    dot.addEventListener('click', function () {
      restartAutoSlide();
      goToSlide(index);
    });

    paginationContainer.appendChild(dot);
  });

  var dots = document.querySelectorAll('.slideshow-dot');

  function goToSlide(index) {
    currentIndex = (index + totalSlides) % totalSlides;

    if (effect === 'fade') {
      slides.forEach((s, i) => {
        s.classList.toggle('active', i === currentIndex);
      });
    } else {
      var offset = -currentIndex * 100;
      carousel.style.transform = 'translateX(' + offset + '%)';
    }

    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === currentIndex);
    });
  }

  function showNextSlide() {
    goToSlide(currentIndex + 1);
  }

  function showPrevSlide() {
    goToSlide(currentIndex - 1);
  }

  function startAutoSlide() {
    autoSlide = setInterval(showNextSlide, speed);
  }

  function restartAutoSlide() {
    clearInterval(autoSlide);
    startAutoSlide();
  }

  document.querySelector('.arrow-next').addEventListener('click', function () {
    showNextSlide();
    restartAutoSlide();
  });

  document.querySelector('.arrow-prev').addEventListener('click', function () {
    showPrevSlide();
    restartAutoSlide();
  });

  goToSlide(0);
  startAutoSlide();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
